/* eslint-disable no-unused-vars */
import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import AddNewLoan from "./atom/AddNewLoan";

function Body({ domainBrand, currency, chargeType, userId }) {
  const { Column } = Table;
  const dictionary = domainBrand.domainBrand["languageDictionary"];

  const [addNewState, updateState] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterValue, setFilterValue] = useState("");

  useEffect(() => {
    if (chargeType === "LOAN") {
      updateState(true);
    }
  }, [chargeType]);

  const addNewStatus = (event) => {
    event.preventDefault();
    updateState(!addNewState);
  };

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary
                ? dictionary["WO_CREATE_ACCOUNT_PRODU_-1238171796"]
                : "Create Account Product"}
            </h1>
          </div>
          <div className="ms-auto pageheader-btn">
            <NavLink
              onClick={addNewStatus}
              to="/"
              className="btn btn-primary btn-icon text-white me-2"
            >
              <span>
                <i className="fa fa-folder-plus" />
              </span>{" "}
              &nbsp;
              {dictionary ? dictionary["button_add_new"] : "Add New"}
            </NavLink>
          </div>
        </div>

        <div className="row row-sm">
          {addNewState && (
            <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div className="card-header bg-primary text-white">
                  <h3 className="card-title">
                    {dictionary
                      ? dictionary["WO_CREATE_ACCOUNT_PRODU_-1238171796"]
                      : "Create Account Product"}
                  </h3>
                </div>
                <AddNewLoan
                  dictionary={dictionary}
                  currency={currency}
                  chargeType={chargeType}
                  userId={userId}
                />
              </div>
            </div>
          )}

          <div className="col-lg-12">
            <div className="card overflow-hidden">
              <div className="col-lg-6 col-md-6 mb-3 mt-2 pt-3 pb-3">
                <input
                  type={"text"}
                  className="form-control px-3"
                  value={filterValue}
                  onChange={(e) => setFilterValue(e.target.value)}
                  placeholder="Search..."
                />
              </div>
              <div className="table-responsive">
                <Table
                  dataSource={[]}
                  className="w-100 table tbody"
                  loading={loading}
                >
                  <Column
                    title="Account Product Name"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                  />
                  <Column
                    title="Account Product Type"
                    dataIndex="createdDate"
                    key="2"
                    className=""
                  />
                  <Column
                    title="Currency code"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                  />
                  <Column
                    title="Account Product Trigger"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                  />
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
